import { CompanyInformationFieldNames } from '@contracts/order/fields/CompanyInformationFields';
import {
  EmailField,
  OptionalStringField,
  StringField,
} from '@src/permitField/PermitFields';

export class CompanyNameField extends StringField {
  public static fieldName = CompanyInformationFieldNames.CompanyName;
}

export class CarrierContactNameField extends StringField {
  public static fieldName = CompanyInformationFieldNames.CarrierContactName;
}

export class CompanyEmailField extends EmailField {
  public static fieldName = CompanyInformationFieldNames.CompanyEmail;
}

export class CompanyPhoneField extends StringField {
  public static fieldName = CompanyInformationFieldNames.CompanyPhone;
}

export class CompanyFaxField extends OptionalStringField {
  public static fieldName = CompanyInformationFieldNames.CompanyFax;
}

export class DoingBusinessAsField extends OptionalStringField {
  public static fieldName = CompanyInformationFieldNames.DoingBusinessAs;
}

export const companyInformationFields = {
  [CompanyNameField.fieldName]: CompanyNameField.validator,
  [DoingBusinessAsField.fieldName]: DoingBusinessAsField.validator,
  [CarrierContactNameField.fieldName]: CarrierContactNameField.validator,
  [CompanyEmailField.fieldName]: CompanyEmailField.validator,
  [CompanyPhoneField.fieldName]: CompanyPhoneField.validator,
  [CompanyFaxField.fieldName]: CompanyFaxField.validator,
};
